import { Empty } from "antd"
import React from "react"
import { NoSearchDataFound } from "./NoSearchDataFound"

interface EmptyTableDataProps {
    isSearchOrFilterActive?: boolean
    title: string
    message: string
    image?: string
}

export const EmptyTableData = ({ isSearchOrFilterActive, title, message, image = "./icons/empty_table.svg" }: EmptyTableDataProps) =>
    isSearchOrFilterActive ? (
        <div className="animation-appear">
            <NoSearchDataFound />
        </div>
    ) : (
        <Empty
            className="animation-appear"
            image={image}
            imageStyle={{
                height: 150,
                marginRight: "auto",
                marginLeft: "auto",
                marginTop: "10%",
                marginBottom: "40px",
                display: "inline-block",
            }}
            description={<span className="text-lg font-bold mt-2 mb-0">{title}</span>}
        >
            <p>{message}</p>
        </Empty>
    )
